import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * user
 * 
 * onDeleteClick(user)
 * onCancelClick
 */

class DeleteUserDialog extends Component {

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>
		
			<DialogTitle>
				Удалить предмет
			</DialogTitle>

			<DialogContent>
				Вы уверены, что ходите удалить пользователя &laquo;{this.props.user.name}&raquo;?
			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteClick === "function") {
							this.props.onDeleteClick(this.props.user)
						}
					}}
				>Удалить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default DeleteUserDialog
